import {
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
  useFieldLabel,
  useTabVisibility,
} from "ra-friendsofbabba";

import React from "react";
import { TextField } from "react-admin";
import VenueField from "./VenueField";

const EquipmentsField = ({ tab = 2, ...props }) => {
  const visible = useTabVisibility(tab);
  const fieldLabel = useFieldLabel({ ...props });

  if (!visible) {
    return null;
  }
  return (
    <Group {...props} wrapper>
      <GroupTitle title={fieldLabel(props?.source)} />
      <ReferenceListField
        {...props}
        tab={tab}
        perPage={5}
        addLabel={false}
        reference="executive-project-equipments"
        target="executive_project_id"
        sort={{ field: "id", order: "ASC" }}
        createLabel="ra.action.add_equipment"
        create={!props.disabled}
        modify={!props.disabled}
        remove={!props.disabled}
        mobilePrimaryText="equipment_type_name"
        mobileSecondaryText="description"
        mobileBreakpoint="xs"
      >
        <TextField
          source="equipment_type_name"
          label={fieldLabel("equipment_type_name")}
        />
        <LongTextField source="description" />
        <VenueField source={fieldLabel("venue_type_id")} />
      </ReferenceListField>
    </Group>
  );
};
export default EquipmentsField;
